import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { FaqConfig } from '@app-types/eligibility/config';

import { LegalsSlugType } from '@helpers/partials';
import { paths } from '@helpers/path';

import { PlanTypeId } from '@constants/plan';
import { BUTTON_STYLE, ELIGIBILITY_JOURNEY, TECHNOLOGY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class BankJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.BANK;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.FAI_BANQUE_WEB;
    protected readonly showComparatorSelection = false;
    protected readonly wordings = {
        mainTitle: 'Vous avez choisi une offre Bbox banque avec la fibre',
        noFiber: "En attendant l'arrivée de la fibre...",
        results: {
            [TECHNOLOGY.FTTH]: 'Bonne nouvelle, vous pouvez profiter des offres Bbox banque !',
        },
    };
    protected readonly tracking = {
        page: 'Eligibilite_test_bboxbanque',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_Fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_Bbox_Banque',
        },
    };
    protected readonly mismatch = {
        icon: IconName.EXCLAMATION_CIRCLE,
        alertTitle: 'La fibre est nécessaire pour profiter des séries spéciales Bbox Banque',
        alertDescription: "En attendant d'être éligible, vous pouvez voir les offres disponibles chez vous.",
        showAddress: true,
        showDivider: false,
        trackingClic: {
            event: 'clic',
            actionClic: 'Clic_redirection',
            categorieClic: 'Popin_adresse_non_eligible_bboxbanque',
            nomClic: 'Voir_les_offres',
        },
        trackingImpression: {
            categorieClic: 'Poppin_eligibilite_ko_bboxbanque',
            nomClic: 'Eligibilite_ko_bboxbanque',
        },
        buttonLabel: 'Voir les offres disponibles',
        buttonStyle: BUTTON_STYLE.PRIMARY,
        ctaRedirectUrl: paths.eligibilityTest,
    };
    protected readonly faq = {} as FaqConfig;
    protected readonly legalsPath = '' as LegalsSlugType;
    protected readonly technologies = [TECHNOLOGY.FTTH];
    protected readonly referrerConfigKey = 'yamaReferrers';
    protected readonly extraCmsBlockByTab = {};
}
